var PaymentStrings = {
    cardExpiryMMYY: function () { return 'MM / YY'; },
    cardZipCode: function () { return 'Zip Code'; },
    removePaymentCardModalTitle: function () {
        return 'Are you sure you want to delete the existing card?';
    },
    removePaymentCardModalSubtitle: function () {
        return 'Deleting this card will erase all the saved details and that your employees will not be able to order until a new valid card is entered.';
    },
    removePaymentCardModalCancelButton: function () { return 'Cancel'; },
    removePaymentCardModalConfirmButton: function () { return 'Confirm Delete'; },
    removePaymentCardSuccess: function () { return 'Card removed successfully'; },
    addCardModalTitle: function () { return 'Add Card Details'; },
    addCardSuccessToast: function () { return 'Card added successfully'; },
    cancelButtonText: function () { return 'Cancel'; },
    saveButtonText: function () { return 'Save Card'; },
    addCardTileTitleText: function () { return 'Credit Card'; },
    addCardAccessibilityText: function () { return 'Add Credit Card'; },
    errorFetchingCards: function () { return 'There is a problem fetching your cards'; },
    tryAgain: function () { return 'Try Again'; },
    currentPaymentMethod: function () { return 'Current Payment Method'; },
    currentPaymentMethodSubText: function () { return 'Credit Card'; },
    savedCreditCardTitle: function () { return 'Saved Credit Card'; },
    addNewCardSectionText: function () { return 'Add New Card'; },
    cardDetailsInputLabel: function () { return 'Card Details'; },
    cardCvcInputLabel: function () { return 'CVC'; },
    expirationInputLabel: function () { return 'Expiration'; },
    zipCodeInputLabel: function () { return 'Zip Code'; },
    noCreditCardWarningText: function () {
        return 'Please add a credit card, as the employees will not be able to use expensed meals unless a credit card is on file.';
    },
    paymentPageSubtitle: function () {
        return 'You will only get charged when your employees place orders using the meal budgets.';
    },
    paymentLimitModalTitle: function () { return "We couldn't add your credit card"; },
    paymentLimitModalDescription: function (max) {
        return "For security purposes, we only allow " + max + " new credit cards to be added per month. Contact support for further assistence.";
    },
    paymentLimitModalContactSupportButtonText: function () { return 'Contact Support'; },
    paymentLimitModalCancelButtonText: function () { return 'Cancel'; },
    paymentAddSuccessInfoBannerTitle: function () {
        return 'Let your credit card issuer know about your meal benefits';
    },
    paymentAddSuccessInfoBannerDescription: function () {
        return "Your card will be charged everytime an employee uses their meal benefit. Let your credit card issuer know so they don't block any transactions.";
    },
    paymentAddWarningBannerText: function () {
        return 'Add a credit card to pay for the meal budgets so that your employees can start placing orders using this benefit.';
    },
    paymentAddWarningBannerPrimaryButton: function () { return 'Add payment method'; },
};
export default PaymentStrings;
